import { Address } from '@ton/core'

/**
 * Normalize wallet address to raw format (0:xxx...)
 * Backend expects addresses in raw format, not user-friendly format (UQ.../EQ...)
 *
 * @param address - Wallet address in any valid TON format
 * @returns Raw format address (0:xxx...) or empty string if invalid
 */
export function normalizeWalletAddress(
  address: string | undefined | null,
): string {
  // Return empty string if address is undefined/null/empty
  if (!address) {
    return ''
  }

  try {
    // Address.parse() handles both raw (0:xxx) and user-friendly (UQ.../EQ...) formats
    const parsedAddress = Address.parse(address)

    // Always return raw format for backend compatibility
    return parsedAddress.toRawString()
  } catch (error) {
    // If parsing fails, return empty string for safety
    console.warn('Failed to parse wallet address:', address, error)
    return ''
  }
}
